<template>
  <v-card
    class="course-detail-card"
    outlined
    elevation="1"
  >
    <v-card-title
      class="ma-1 teal lighten-5 rounded-lg pa-1"
      style="line-height: normal;"
    >
      <span class="text-h6">{{course.name}}</span>
      <span v-if="course.precautionary_statement" style="font-size:0.8rem">{{course.precautionary_statement}}</span>
    </v-card-title>
    <table class="pa-1 mx-2 course-detail-table">
      <tr>
        <th style="width:60px">
          達成目標
        </th>
        <td style="word-wrap: break-word;" v-html="course.objective"></td>
      </tr>
      <tr>
        <th>
          基本項目
        </th>
        <td style="word-wrap: break-word;" v-html="course.basic_item"></td>
      </tr>
      <tr>
        <th>
          記録表の付け方
        </th>
        <td style="word-wrap: break-word;" v-html="course.recording_method"></td>
      </tr>
      <tr>
        <th>
          現在参加中
        </th>
        <td style="word-wrap: break-word;">{{course.participants}} 人</td>
      </tr>
    </table>
    <div v-if="course.youtube_url">
      <v-img
        @click="openYoutube(course.youtube_url)"
        class="ma-2"
        :src="'/image/youtube/' + course.youtube_thumbnail_file_name"
      ></v-img>
    </div>
    <v-card-actions>
      <v-btn
        @click="openDetailPDF(course.detailed_document_file_name)"
        color="info"
        v-if="!isLight"
      >
        詳細の資料
      </v-btn>
      <v-btn
        @click="openDetailPDF(course.detailed_document_file_name + '_light')"
        color="info"
        v-if="isLight"
      >
        詳細の資料
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'courseDetailCard',
  data () {
    return {
    }
  },
  props: ['course'],
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    // 運用テストかどうか（健チャレLight版）
    isLight () {
      return process.env.VUE_APP_IS_LIGHT
    }
  },
  async mounted () {
  },
  methods: {
    openDetailPDF (target) {
      window.open('/course/detail/' + target + '.pdf', '_blank')
    },
    openYoutube (target) {
      window.open(target, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.course-detail-card {
  display: flex !important;
  flex-direction: column;
}
.course-detail-table {
  table-layout: fixed;
  width: 95%;
  border-collapse: collapse;
  font-size: 0.8rem !important;
  th, td {
    padding: 5px 10px;
    border: 1px solid #ccc;
  }
  th {
    background-color: #FFF8E1;
    font-weight: 500;
  }
}
</style>
